import { ComponentInterface, FunctionalComponent, h } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';

interface Hint360Props {
  loading: boolean;
  legacyAssets: boolean;
}

const Hint360 = (that: ComponentInterface): FunctionalComponent<Hint360Props> => {
  return ({ loading, legacyAssets }) => {
    const { WbIcon } = transformTagNames(that, 'wb-360-viewer', ['wb-icon']);
    const viewBox = legacyAssets ? '0 0 958 86' : '0 0 958 120';
    const ellipseRY = legacyAssets ? '42.5' : '59.5';

    return (
      <div class="hint-360" aria-hidden="true">
        <svg viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
          <linearGradient id="gradient-fade-out" x1="50%" y1="0%" x2="50%" y2="100%">
            <stop stop-opacity="0" offset="10%" stop-color="var(--hint-base-color)"></stop>
            <stop offset="100%" stop-color="var(--hint-base-color)"></stop>
          </linearGradient>
          <mask id="icon-mask">
            <rect x="0" y="0" width="100%" height="100%" fill="white"></rect>
            <rect x="47.5%" y="90%" width="5%" height="20%" fill="black"></rect>
          </mask>
          <g mask="url(#icon-mask)">
            <ellipse cx="50%" cy="50%" rx="478" ry={ellipseRY} stroke="url(#gradient-fade-out)" fill="none" fill-rule="evenodd" class="base"></ellipse>
            {loading && <ellipse class="spinner" cx="50%" cy="50%" rx="478" ry={ellipseRY} stroke="url(#gradient-fade-out)" fill="none" fill-rule="evenodd"></ellipse>}
          </g>
        </svg>
        <WbIcon class="icon" aria-hidden="true" name="bds/view-360/24" />
      </div>
    );
  };
};

export { Hint360 as bindHint360 };
